const cedSftpPass = {
  type: 'ConnectEd',
  key: 'ced_sftp_pass',
  value: ''
};

export default cedSftpPass;



// WEBPACK FOOTER //
// ./app/models/cedSftpPass.js